import { Pipe, PipeTransform } from '@angular/core';
import { ConvertedIntentTopicInterface } from '../models/converted-intent-topic.interface';


@Pipe({
    name: 'intentDataTopicCount',
    standalone: false
})
export class IntentDataTopicCountPipe implements PipeTransform {
    transform(topics: ConvertedIntentTopicInterface[]): number {
        return topics
            ?.filter((topic: ConvertedIntentTopicInterface) => topic.topic_id)
            ?.length;
    }
}
